import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteAgencyModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "deleteAgencyModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-450px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pt-8 pb-5 px-5" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fs-5 fw-bold" }, " Eliminar agencia "),
  /*#__PURE__*/_createElementVNode("span", {
    "data-bs-dismiss": "modal",
    class: "pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "isax-close-circle text-white fs-2x pointer" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body scroll-y px-10 px-lg-15x pt-10 pb-5" }
const _hoisted_6 = { class: "row g-9 mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-2 text-start fs-base" }, " ¿Desea eliminar la agencia? Sus datos serán eliminados y no se podrán deshacer ", -1)
const _hoisted_8 = { class: "row text-end" }
const _hoisted_9 = { class: "listaButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary fs-base",
                    "data-bs-dismiss": "modal",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
                  }, " Cancelar ")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn btn-primary fs-base",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteAgency && _ctx.deleteAgency(...args)))
                  }, " Eliminar agencia ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 512))
}